import React, { useState, useEffect, useRef } from 'react';
import {useGlobal} from "reactn";
import {
    FiMic
} from "react-icons/fi";
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';

const VoiceToText = ({value, setValue, sendMessage, color = '#0067ac'}) => {
    const [isVoiceActive, setIsVoiceActive] = useState(false);
    const [originalValue, setOriginalValue] = useState('');
    const [micColor, setMicColor] = useState(color);

    const timeoutRef = useRef(null);


    const {
        transcript,
        interimTranscript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();

    useEffect(() => {
        if (isVoiceActive) {
            setValue(originalValue + ' ' + interimTranscript);
        }

        // Reset thời gian nếu có transcript
        if (interimTranscript) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);  // Xóa timeout cũ nếu có
            }

            // Set timeout mới sau x giây không nói
            timeoutRef.current = setTimeout(() => {
                if (isVoiceActive) {
                    setMicColor(color);  // Đổi màu icon về mặc định
                    SpeechRecognition.stopListening();
                    setIsVoiceActive(false);
                    resetTranscript();

                    //Gửi tin nhắn
                    sendMessage(interimTranscript, false)
                }
            }, 1200); // Nếu người dùng không nói trong 1,2 giây
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current); // Clear timeout khi component bị unmount
            }
        };

    }, [interimTranscript, isVoiceActive, originalValue, setValue]);
    

    const toggleVoice = () => {
        if (!browserSupportsSpeechRecognition) {
            console.log("Trình duyệt không hỗ trợ tính năng nhận diện giọng nói.");
            return;
        }

        startListening();
    };

    const startListening = () => {
        if (!isVoiceActive) {
            setOriginalValue(value); // Lưu lại nội dung đang có
            resetTranscript();
            SpeechRecognition.startListening({ continuous: true, language: 'vi-VN' });
            setIsVoiceActive(true);
            setMicColor('red');  // Màu đỏ khi bắt đầu nói
        } else {
            SpeechRecognition.stopListening();
            setIsVoiceActive(false);
            setMicColor(color);  // Màu bình thường khi dừng nói
            resetTranscript();
        }
    };


    return (
        <div>
            <div className="button attach" onClick={() => toggleVoice()}>
                <FiMic color={micColor} size="30" style={{ cursor: 'pointer' }}/>
            </div>
        </div>
    );
};

export default VoiceToText;
